import { NgModule } from '@angular/core';
import { TokenInterceptorService } from './token-interceptor.service';
// import { CiptechServicesModule } from '../services/services.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingInterceptorService } from './loading-interceptor.service';

@NgModule({
    // imports: [CiptechServicesModule],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptorService,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoadingInterceptorService,
            multi: true
        }
    ]
})
export class CiptechInterceptorModule { }
